import { createSlice, current } from '@reduxjs/toolkit'

export const windowSlice = createSlice({
  name: "window",
  initialState: {
    screenWidth: typeof window === "object" ? window.innerWidth : null,
    screenHeight: typeof window === "object" ? window.innerHeight : null,
  },
  reducers: {
    screenResize: (state, action) => {
      // console.log(current(state));
      return action.payload;
    },
  },
});

export const { screenResize } = windowSlice.actions;

export const selectWindow = (state) => state.window; 

export const windowReducer = windowSlice.reducer;

export default windowSlice.reducer;